import { useLocation } from 'react-router';
import { administracion, analista, basic } from '../../routes/routesGroups';

export const APP_TITLE_CHANGE = 'APP_TITLE_CHANGE';

export const AppTitleChange = title => {
  return {
    type: APP_TITLE_CHANGE,
    payload: title,
  };
};

export const UpdateAppTitleChange = () => {
  const location = useLocation().pathname;
  var title = '';

  if (analista.includes(location)) {
    title = 'Seguimiento de Reclamos';
  }

  if (administracion.includes(location)) {
    title = 'Gestión de Usuarios';
  }

  if (basic.includes(location)) {
    title = 'Extranet';
  }

  return {
    type: APP_TITLE_CHANGE,
    payload: title,
  };
};
